// extracted by mini-css-extract-plugin
module.exports = {"container":"stubMatchRow__container___rA1HM"};